import { ChangeEvent, useRef } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { openNotification } from '../../UI';
import { clientGetProfileImageUploadUrl } from '../../graphql/profileImage';
import { useGraphqlClient } from '../../graphql';

export const useUpdateProfileImage = () => {
  const fileSelectorRef = useRef<HTMLInputElement>(null);
  const { t: tFile } = useTranslation('file');
  const gqlClient = useGraphqlClient();

  const uploadFile = useMutation({
    mutationFn: async (input: { uploadUrl: string; file: File }) => {
      const uploadUrl = input.uploadUrl;
      const fileBuffer = await input.file.arrayBuffer();
      const contentType = input.file.type;

      return await fetch(uploadUrl, {
        body: fileBuffer,
        headers: {
          'Content-Type': contentType,
        },
        method: 'PUT',
      });
    },
    onSuccess: () => {
      openNotification({
        description: tFile('success-uploaded-profile-image'),
      });
    },
    onError: (e) => {
      console.error(e);
      openNotification({
        type: 'error',
        description: tFile('error-unable-to-upload'),
      });
    },
  });

  const onSelectFile = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const uploadUrl = await clientGetProfileImageUploadUrl(gqlClient, {
      name: file.name,
    });

    uploadFile.mutate({ uploadUrl, file });
  };

  return {
    onSelectFile,
    fileSelectorRef,
    loading: uploadFile.isLoading,
  };
};
